"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var socket_io_client_1 = __importDefault(require("socket.io-client"));
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
function getCookie(name) {
    var gettoken = js_cookie_1.default.get(name);
    return gettoken;
}
var Notification = function () {
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)([
        {
            id: 0,
            subject: "",
            message: "",
            createdAt: "",
            status: "",
            userId: 0,
        },
    ]), notifications = _b[0], setNotifications = _b[1];
    var token = getCookie("token");
    var socket = token
        ? (0, socket_io_client_1.default)(process.env.BACKEND_LINK, { query: { token: token } })
        : undefined;
    (0, react_1.useEffect)(function () {
        if (token == undefined) {
            return;
        }
        socket === null || socket === void 0 ? void 0 : socket.on("allnotifications", function (nots) {
            setLoading(false);
            setNotifications(nots);
        });
    }, [socket, token]);
    if (token == undefined) {
        return react_1.default.createElement(react_1.default.Fragment, null, "Please Login");
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, { sx: { backgroundColor: "white", borderRadius: "7px", p: 5 }, component: "div" },
            loading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CircularProgress_1.default, null),
                " ",
                react_1.default.createElement(material_1.Typography, { paragraph: true, sx: { fontWeight: 700 } }, "Getting notifications ..."),
                " ")),
            react_1.default.createElement(system_1.Stack, { direction: "column", gap: "5px" }, notifications
                ? notifications.length <= 0
                    ? "You have no notifications"
                    : notifications.map(function (noti, indx) {
                        return (react_1.default.createElement("div", { key: indx },
                            react_1.default.createElement(material_1.Typography, { sx: { fontWeight: 600 } }, noti.subject),
                            react_1.default.createElement(material_1.Typography, { paragraph: true }, noti.message),
                            react_1.default.createElement(material_1.Typography, { sx: { mt: -8 }, align: "right", component: "small" },
                                noti.createdAt.split("T")[0],
                                " ",
                                noti.createdAt.split("T")[1]),
                            react_1.default.createElement(material_1.Divider, null)));
                    })
                : " You have no notifications. "))));
};
exports.default = Notification;
